<app-table-skeleton class="overflow-x-auto" [columns]="columns()" />
